var _defs, _style, _g, _g2, _path, _g3, _tspan, _tspan2, _tspan3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-calendar-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.51-4l32.11 4.51-4.51 32.11-32.11-4.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0.7,
    y1: 12.5,
    x2: 24.8,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#738186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c898f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8a90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 14,
    y1: 20.3,
    x2: 14.2,
    y2: 21.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6d64"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre } \r\n\t\t.s0 { fill: url(#g1) } \r\n\t\t.s1 { fill: url(#g2) } \r\n\t\t.s2 { fill: #fbfbfb } \r\n\t\t.s3 { fill: #e95850 } \r\n\t\t.t4 { font-size: 4px;fill: #ffffff;font-family: \"Segoe UI\" } \r\n\t\t.t5 { font-size: 13px;fill: #000000;font-family: \"Segoe UI\" } \r\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Calendar",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-2",
    className: "s0",
    d: "m0.7 2.3c0-0.2 0.2-0.4 0.4-0.5l22.8-0.4c0.2 0 0.4 0.2 0.4 0.5l0.5 21.6c0 0.3-0.2 0.5-0.5 0.5l-22.7 0.5c-0.3 0-0.5-0.2-0.5-0.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow-2",
    className: "s1",
    d: "m23.5 22.8c0 0-5.3 0.1-11.3 0.2-6 0.2-9.8 0-9.8 0l-0.3-21.2 20.7-0.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sheet",
    className: "s2",
    d: "m23.4 21.7l-11.3 0.3c-6 0.1-9.8 0-9.8 0l-0.3-21.4 20.9-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Month"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2-2",
    className: "s3",
    d: "m2 0.5l20.9-0.4 0.2 6.3-21 0.4z"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "JUL",
    style: {
      transform: "matrix(1,-0.017,.017,1,8.842,4.719)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t4"
  }, "JUL\r\n")))), /*#__PURE__*/React.createElement("g", {
    id: "Date"
  }, /*#__PURE__*/React.createElement("text", {
    id: 7,
    style: {
      transform: "matrix(1,-0.017,.017,1,11.143,17.819)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t5"
  }, "7\r\n"))), /*#__PURE__*/React.createElement("text", {
    id: 1,
    style: {
      transform: "matrix(1,-0.017,.017,1,5.266,17.796)"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t5"
  }, "1\r\n")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.a5054cce23f86156da23563cb18892ab.svg";
export { ForwardRef as ReactComponent };